import { Table, TableColumnsType } from 'antd';
import _ from 'lodash';
import { FC, useEffect, useState } from 'react';
import { useSelector } from "react-redux";
import { RootState } from "../../../store/rootReducer";
import { useTranslation } from 'react-i18next';
import exportTitleTable from "../../../lib/exportTitleTable";
import { getCommonCodeLabel } from '../../../lib/store';
import { IPtStatsByLevel } from '../../../models/statistics.model';
import DownloadButton from '../../DownloadButton';
import moment from 'moment';

interface IProps {
  rawData: IPtStatsByLevel[] | undefined;
  eduStepCode: string | undefined;
  excelCampusCode: string;
  excelPeriod: string|undefined;
}

const PtStatsByLevel: FC<IProps> = ({ rawData, eduStepCode, excelCampusCode, excelPeriod }) => {
  const { commonCodes } = useSelector((state: RootState) => state.commonCode);
  // SY0006 = 학년
  const SY0006 = commonCodes.find((item) => item.commonCode === 'SY0006')?.detailCode;
  const { t } = useTranslation();
  const { campusData } = useSelector((state: RootState) => state.campusData);
  
  const [data, setData] = useState<IPtStatsByLevel[]>([]);
  const [colEduStepCode, setColLocalEduStepCode] = useState<string>();

  useEffect(() => {
    if (rawData) {
      let _data: any = _.cloneDeep(rawData);
      
      if (rawData?.length) {
        _data.forEach((item: any, idx: number) => {
          item.rowIdx = idx;
          //학년별 등록률 셋팅
          item.rrk7 = (item.tck7 || item.rck7) ? Math.round(item.rck7 / item.tck7 * 1000) / 10 : '-'; 
          item.rr01 = (item.tc01 || item.rc01) ? Math.round(item.rc01 / item.tc01 * 1000) / 10 : '-'; 
          item.rr02 = (item.tc02 || item.rc02) ? Math.round(item.rc02 / item.tc02 * 1000) / 10 : '-'; 
          item.rr03 = (item.tc03 || item.rc03) ? Math.round(item.rc03 / item.tc03 * 1000) / 10 : '-'; 
          item.rr04 = (item.tc04 || item.rc04) ? Math.round(item.rc04 / item.tc04 * 1000) / 10 : '-'; 
          item.rr05 = (item.tc05 || item.rc05) ? Math.round(item.rc05 / item.tc05 * 1000) / 10 : '-'; 
          item.rr06 = (item.tc06 || item.rc06) ? Math.round(item.rc06 / item.tc06 * 1000) / 10 : '-'; 
          item.rr07 = (item.tc07 || item.rc07) ? Math.round(item.rc07 / item.tc07 * 1000) / 10 : '-'; 
          item.rr08 = (item.tc08 || item.rc08) ? Math.round(item.rc08 / item.tc08 * 1000) / 10 : '-'; 
          item.rr09 = (item.tc09 || item.rc09) ? Math.round(item.rc09 / item.tc09 * 1000) / 10 : '-'; 
        });

        _data = _.concat(settingTotalRow(), _data);
      }

      setData(_data);
      setColLocalEduStepCode(eduStepCode);
    }
  }, [rawData]);

  //총 합계 셋팅
  const settingTotalRow = () => {
    const totalArray: any = [];

    if (rawData) {
      if (rawData?.length) {
        const total: any = {
          campusName: t('statistics.placementTest.data1'),
          courseName: '-',
          examTypeName: '-',
          eduStepCode: '',
          courseCode: 0,
          tck7: 0, rck7: 0, rrk7: 0,
          tc01: 0, rc01: 0, rr01: 0,
          tc02: 0, rc02: 0, rr02: 0,
          tc03: 0, rc03: 0, rr03: 0,
          tc04: 0, rc04: 0, rr04: 0,
          tc05: 0, rc05: 0, rr05: 0,
          tc06: 0, rc06: 0, rr06: 0,
          tc07: 0, rc07: 0, rr07: 0,
          tc08: 0, rc08: 0, rr08: 0,
          tc09: 0, rc09: 0, rr09: 0,
          tc10: 0, rc10: 0, rr10: 0,
        };

        rawData.forEach((item: any) => {
          total.tck7 += item.tck7;
          total.rck7 += item.rck7;
          total.tc01 += item.tc01;
          total.rc01 += item.rc01;
          total.tc02 += item.tc02;
          total.rc02 += item.rc02;
          total.tc03 += item.tc03;
          total.rc03 += item.rc03;
          total.tc04 += item.tc04;
          total.rc04 += item.rc04;
          total.tc05 += item.tc05;
          total.rc05 += item.rc05;
          total.tc06 += item.tc06;
          total.rc06 += item.rc06;
          total.tc07 += item.tc07;
          total.rc07 += item.rc07;
          total.tc08 += item.tc08;
          total.rc08 += item.rc08;
          total.tc09 += item.tc09;
          total.rc09 += item.rc09;
          total.tc10 += item.tc10;
          total.rc10 += item.rc10;
        })

        total.rrk7 = (total.tck7 || total.rck7) ? Math.round(total.rck7 / total.tck7 * 1000) / 10 : '-'; 
        total.rr01 = (total.tc01 || total.rc01) ? Math.round(total.rc01 / total.tc01 * 1000) / 10 : '-'; 
        total.rr02 = (total.tc02 || total.rc02) ? Math.round(total.rc02 / total.tc02 * 1000) / 10 : '-'; 
        total.rr03 = (total.tc03 || total.rc03) ? Math.round(total.rc03 / total.tc03 * 1000) / 10 : '-'; 
        total.rr04 = (total.tc04 || total.rc04) ? Math.round(total.rc04 / total.tc04 * 1000) / 10 : '-'; 
        total.rr05 = (total.tc05 || total.rc05) ? Math.round(total.rc05 / total.tc05 * 1000) / 10 : '-'; 
        total.rr06 = (total.tc06 || total.rc06) ? Math.round(total.rc06 / total.tc06 * 1000) / 10 : '-'; 
        total.rr07 = (total.tc07 || total.rc07) ? Math.round(total.rc07 / total.tc07 * 1000) / 10 : '-'; 
        total.rr08 = (total.tc08 || total.rc08) ? Math.round(total.rc08 / total.tc08 * 1000) / 10 : '-'; 
        total.rr09 = (total.tc09 || total.rc09) ? Math.round(total.rc09 / total.tc09 * 1000) / 10 : '-'; 

        totalArray.push(total);
      }
    }

    return totalArray;
  }

  const getColumns = () => {
    const firstColumns: TableColumnsType<IPtStatsByLevel> = [
      {
        title: t('common.menu.campus'),
        dataIndex: 'campusName',
        key: 'campusName',
        align: 'center',
      },
      {
        title: t('statistics.dttt.column1'),
        dataIndex: 'courseName',
        key: 'courseName',
        align: 'center',
      }, 
      {
        title: t('statistics.placementTest.placeholder1'),
        dataIndex: 'examTypeName',
        key: 'examTypeName',
        align: 'center',
      },   
    ];

    let lastColumns: TableColumnsType<IPtStatsByLevel> = [];

    if('EM'=== colEduStepCode) {
      lastColumns = [
        {
          title: getCommonCodeLabel('SY0006', 'K7', 'ko'),
          align: 'center',
          children: [
            {
              title: t('entrance.schedule.text3'),
              align: 'center',
              dataIndex: 'tck7',
            },
            {
              title: t('student.student.title5'),
              align: 'center',
              dataIndex: 'rck7',
            },
            {
              title: t('entrance.statistics.column7') + '(%)',
              align: 'center',
              dataIndex: 'rrk7',
            },
          ]
        },
        {
          title: getCommonCodeLabel('SY0006', '01', 'ko'),
          align: 'center',
          children: [
            {
              title: t('entrance.schedule.text3'),
              align: 'center',
              dataIndex: 'tc01',
            },
            {
              title: t('student.student.title5'),
              align: 'center',
              dataIndex: 'rc01',
            },
            {
              title: t('entrance.statistics.column7') + '(%)',
              align: 'center',
              dataIndex: 'rr01',
            },
          ]
        },
        {
          title: getCommonCodeLabel('SY0006', '02', 'ko'),
          align: 'center',
          children: [
            {
              title: t('entrance.schedule.text3'),
              align: 'center',
              dataIndex: 'tc02',
            },
            {
              title: t('student.student.title5'),
              align: 'center',
              dataIndex: 'rc02',
            },
            {
              title: t('entrance.statistics.column7') + '(%)',
              align: 'center',
              dataIndex: 'rr02',
            },
          ]
        },
        {
          title: getCommonCodeLabel('SY0006', '03', 'ko'),
          align: 'center',
          children: [
            {
              title: t('entrance.schedule.text3'),
              align: 'center',
              dataIndex: 'tc03',
            },
            {
              title: t('student.student.title5'),
              align: 'center',
              dataIndex: 'rc03',
            },
            {
              title: t('entrance.statistics.column7') + '(%)',
              align: 'center',
              dataIndex: 'rr03',
            },
          ]
        },
        {
          title: getCommonCodeLabel('SY0006', '04', 'ko'),
          align: 'center',
          children: [
            {
              title: t('entrance.schedule.text3'),
              align: 'center',
              dataIndex: 'tc04',
            },
            {
              title: t('student.student.title5'),
              align: 'center',
              dataIndex: 'rc04',
            },
            {
              title: t('entrance.statistics.column7') + '(%)',
              align: 'center',
              dataIndex: 'rr04',
            },
          ]
        },
        {
          title: getCommonCodeLabel('SY0006', '05', 'ko'),
          align: 'center',
          children: [
            {
              title: t('entrance.schedule.text3'),
              align: 'center',
              dataIndex: 'tc05',
            },
            {
              title: t('student.student.title5'),
              align: 'center',
              dataIndex: 'rc05',
            },
            {
              title: t('entrance.statistics.column7') + '(%)',
              align: 'center',
              dataIndex: 'rr05',
            },
          ]
        },
        {
          title: getCommonCodeLabel('SY0006', '06', 'ko'),
          align: 'center',
          children: [
            {
              title: t('entrance.schedule.text3'),
              align: 'center',
              dataIndex: 'tc06',
            },
            {
              title: t('student.student.title5'),
              align: 'center',
              dataIndex: 'rc06',
            },
            {
              title: t('entrance.statistics.column7') + '(%)',
              align: 'center',
              dataIndex: 'rr06',
            },
          ]
        },
      ]
    } else {
      lastColumns = [
        {
          title: getCommonCodeLabel('SY0006', '06', 'ko'),
          align: 'center',
          children: [
            {
              title: t('entrance.schedule.text3'),
              align: 'center',
              dataIndex: 'tc06',
            },
            {
              title: t('student.student.title5'),
              align: 'center',
              dataIndex: 'rc06',
            },
            {
              title: t('entrance.statistics.column7') + '(%)',
              align: 'center',
              dataIndex: 'rr06',
            },
          ]
        },
        {
          title: getCommonCodeLabel('SY0006', '07', 'ko'),
          align: 'center',
          children: [
            {
              title: t('entrance.schedule.text3'),
              align: 'center',
              dataIndex: 'tc07',
            },
            {
              title: t('student.student.title5'),
              align: 'center',
              dataIndex: 'rc07',
            },
            {
              title: t('entrance.statistics.column7') + '(%)',
              align: 'center',
              dataIndex: 'rr07',
            },
          ]
        },
        {
          title: getCommonCodeLabel('SY0006', '08', 'ko'),
          align: 'center',
          children: [
            {
              title: t('entrance.schedule.text3'),
              align: 'center',
              dataIndex: 'tc08',
            },
            {
              title: t('student.student.title5'),
              align: 'center',
              dataIndex: 'rc08',
            },
            {
              title: t('entrance.statistics.column7') + '(%)',
              align: 'center',
              dataIndex: 'rr08',
            },
          ]
        },
        {
          title: getCommonCodeLabel('SY0006', '09', 'ko'),
          align: 'center',
          children: [
            {
              title: t('entrance.schedule.text3'),
              align: 'center',
              dataIndex: 'tc09',
            },
            {
              title: t('student.student.title5'),
              align: 'center',
              dataIndex: 'rc09',
            },
            {
              title: t('entrance.statistics.column7') + '(%)',
              align: 'center',
              dataIndex: 'rr09',
            },
          ]
        },
      ]
    }

    return _.concat(firstColumns, lastColumns);
  };

  const onExportTable = () => {
    const currentDate = moment(new Date());

    let excelTitle = `${t('statistics.placementTest.title1')}(${t('statistics.dttt.column1')})`;
    let arrSubTitle = [];
    let campusNames = campusData.find(campus => excelCampusCode == campus.campusCode)?.campusKorName;;
    
    arrSubTitle.push(t('common.excel.campus') + " : " + campusNames);
    if(excelPeriod !== '') {
      arrSubTitle.push(t('common.excel.period') + " : " + excelPeriod);
    }

    exportTitleTable(
      getColumns(),
      data,
      `${t('statistics.placementTest.title1')}(${t(
        'statistics.dttt.column1',
      )})_(${currentDate.format('YYYYMMDD')})`,
      `${t('statistics.dttt.column1')}`,
      [20, 12, 12, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10],
      excelTitle, arrSubTitle
    );
  };

  return (
    <>
      <div className="comm-table__area line-type">
        <Table
          columns={getColumns()}
          dataSource={data}
          rowClassName={(record: any) => record.courseCode === 0 ? 'tfoot' : ''}
          pagination={{
            current: 1,
            pageSize: 999999999,
          }}
          rowKey={'rowIdx'}
        />
      </div>
      <div className="comm-bx__between">
        <DownloadButton onClick={onExportTable} />
      </div>
    </>
  );
};

export default PtStatsByLevel;
